import { Schema } from 'rsuite'

const { StringType, ArrayType, NumberType } = Schema.Types

export const productGroupFormValidationModel = Schema.Model({
  name: StringType().isRequired('Заполните название'),
  label: StringType().isRequired('Заполните лейбл'),
  type: StringType().isRequired('Заполните тип')
})
